import React from "react";
import { Helmet } from "react-helmet";
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';

const DynamicHelmet: React.FC = () => {
  const { reactAppName } = useAvailableModulesContext();
  const description = `Plataforma interna da ${reactAppName}`;

  return (
    <Helmet>
      <title>{reactAppName}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default DynamicHelmet;
